/**
 * 国内户 / 海外户 区域标识统一入口
 * __APP_REGION__ 在 config/config.ts 的 define 中注入：
 *   - 'prod' = 国内户（默认；dev 未指定 APP_REGION 也按此处理）
 *   - 'hwh'  = 海外户
 * 用独立的全局常量而不是 process.env.APP_REGION，因为后者作为属性访问
 * 在 UMI/webpack 的 transform 链里替换时机不稳定（实测会被替换成 false）。
 */

export type AppRegion = 'prod' | 'hwh'

export const APP_REGION: AppRegion = __APP_REGION__ === 'hwh' ? 'hwh' : 'prod'

export const IS_HWH = APP_REGION === 'hwh'

export const REGION_LABEL = IS_HWH ? '海外户' : '国内户'

/** Logo / 顶部品牌名：国内 / 海外统一用 New Rate，区域差异交给标签和文案 */
export const BRAND_NAME = 'New Rate'

/** 登录/注册/找密页副标题里的站名（区域区分已在标题旁的标签上体现，副标题保持一致） */
export const SITE_NAME = 'New Rate 智能营销系统'
